import { z } from 'zod';

export const qaReviewKpiSchema = z.object({
    qaUserId: z.number().int(),
    updateOwnerId: z.number().int(),
    reviewedUpdates: z.number().int().nonnegative(),
    cellsScope: z.number().int().nonnegative(),
});

export type QaReviewKpi = z.infer<typeof qaReviewKpiSchema>;

export const qaReviewKpisFiltersSchema = z.object({
    from: z.number().int(),
    to: z.number().int(),
});

export type QaReviewKpisFiltersType = z.infer<typeof qaReviewKpisFiltersSchema>;
